
import { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash,faThumbsUp } from '@fortawesome/free-solid-svg-icons';
function App() {
  const[newTitle,setTitle]=useState("");
  const[newDesc,setNewDesc]=useState("");
  const [todoList,setTodoList]=useState([]);
  const[completeList,setCOmpleteList]=useState([]);
  const [completeScreen,setCompleteScreen]=useState(false);
  function addTodos(){
    let newTodo={
      title:newTitle,
      desc:newDesc
    }
    let newList=[...todoList];
    newList.push(newTodo);
    setTodoList(newList);
    localStorage.setItem('todolist',JSON.stringify(newList));
  };
  const deletedTodos=(index)=>{
    let reducedList=[...todoList];
    reducedList.splice(index);
    localStorage.setItem('todolist',JSON.stringify(reducedList));
    setTodoList(reducedList);
  }
  const completedTodos=(index)=>{
    let now=new Date();
    let dd=now.getDate();
    let mm=now.getMonth();
    let yyyy=now.getFullYear();
    let h=now.getHours();
    let m=now.getMinutes();
    let s=now.getSeconds();
    let completedOn=dd + " - " +mm+" - "+ yyyy +" at "+h+":"+m+":"+s;
    let filteredTodo={
      ...todoList[index],
      completedOn:completedOn
    }
    let updatedTodos=[...completeList];
    updatedTodos.push(filteredTodo);
    setCOmpleteList(updatedTodos);
    deletedTodos(index);
    localStorage.setItem('completelist',JSON.stringify(updatedTodos));
  }
  const deletedcompletedTodos=(index)=>{
    let newList=[...completeList];
    newList.splice(index);
    setCOmpleteList(newList);
    let reducedList=[...completeList];
    reducedList.splice(index);
    localStorage.setItem('completelist',JSON.stringify(reducedList));
    setCOmpleteList(reducedList);
  }
  useEffect(()=>{
    let savedTodos=JSON.parse(localStorage.getItem('todolist'));
    let completeTodos=JSON.parse(localStorage.getItem('completelist'));
    if(savedTodos){
      setTodoList(savedTodos);
    }
    if(completeTodos){
      setCOmpleteList(completeTodos);
    }
  },[]);
  return (
    <div className='App'>
      <h1 className='heading text-primary shadow'>My Todos</h1>
      
      <div className='m-4 bg-dark p-2 card shadow'>
        <div className='todo-header d-flex border-bottom pb-2'>
          <div className='m-2 form-control'>
            <h2 className='sub-head text-primary title'>Title:</h2>
            <input type="text" placeholder='enter title of your task...' className='form-control w-10' value={newTitle} onChange={(e)=>{setTitle(e.target.value)
}}/>
          </div>
          <div className='m-2 form-control'>
            <h2 className='sub-head text-primary'>Description:</h2>
            <input type="text" placeholder='enter description of your task...' className='form-control w-10' value={newDesc} onChange={(e)=>{setNewDesc(e.target.value)}}/>
          </div>
          <div className='m-2'>
            <button className='btn btn-primary' onClick={addTodos}>ADD</button>
          </div>
        </div>
        <div className='btn-area btn-container'>
            <button className={`button secondery completeScreen ${completeScreen === false && 'active'}`} onClick={()=>setCompleteScreen(false)}>Todo</button>
            <button className={`button secondery completeScreen ${completeScreen === true && 'active'}`} onClick={()=>setCompleteScreen(true)}>Completed</button>
        </div>
        {!completeScreen && (
        <div className="todo-list d-flex flex-direction-column justify-content-center ">
          <div className='bg-dark w-100 m-3 p-2'>
              {todoList.map((todo,index)=>{
                return(
                  <div className="todo-list-item" key={index}>
                    <div className='box'>
                        <h3 className='text-info font-weight-bold'>{todo.title}</h3>
                        <p className='text-dark'>{todo.desc}</p>
                    </div>
                    <div className='box box-1'>
                    <FontAwesomeIcon icon={faTrash} size="2x"  onClick={()=>deletedTodos(index)} className='delete-icon'/>
                    <FontAwesomeIcon icon={faThumbsUp} size="2x" color="blue" className='thumb-icon' onClick={()=>completedTodos(index)}/>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
        )}
      {completeScreen && (
        <div className="todo-list d-flex flex-direction-column justify-content-center">
        <div className='bg-dark w-100 m-3 p-2'>
            {completeList.map((todo,index)=>{
              return(
                <div className="todo-list-item" key={index}>
                  <div className='box box-2'>
                      <h3 className='text-info font-weight-bold'>{todo.title}</h3>
                      <p className='text-dark'>{todo.desc}</p>
                      <p><small>Completed On:{todo.completedOn}</small></p>
                  </div>
                  <div className='box box-1'>
                  <FontAwesomeIcon icon={faTrash} size="2x"  onClick={()=>deletedcompletedTodos(index)} className='delete-icon'/>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
      )
      }
      </div>
    </div>
  );
}

export default App;
